import { render, staticRenderFns } from "./TabListPosture.vue?vue&type=template&id=249236c6&scoped=true&"
import script from "./TabListPosture.vue?vue&type=script&lang=js&"
export * from "./TabListPosture.vue?vue&type=script&lang=js&"
import style0 from "./TabListPosture.vue?vue&type=style&index=0&id=249236c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "249236c6",
  null
  
)

export default component.exports